module.exports = __webpack_public_path__ + "static/media/breakdownTable3.24a2e9b6.png";